import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { useSelector } from 'react-redux';
import { client, Resource } from 'api';
import getCurrentGroupId from 'store/selectors/getCurrentGroupId';

interface ReportingChapterNameUpdate {
  name: string;
}
interface ReportingChapterUpdateResponse extends ReportingChapterNameUpdate {
  id: number;
  groupId: number;
  setupId: number;
}

export function useUpdateReportingChapterMutation() {
  const queryClient = useQueryClient();
  const groupId = useSelector(getCurrentGroupId);

  return useMutation<
    ReportingChapterUpdateResponse,
    AxiosError,
    ReportingChapterNameUpdate
  >(
    ({ name }) =>
      client
        .put(`${Resource.ReportingChapters}`, { name }, { params: { groupId } })
        .then(({ data }) => data),
    { onSuccess: () => queryClient.invalidateQueries(['group', groupId]) }
  );
}
